import BlogsSlider from "./components/blogs-slider";
import {Booklets} from "./components/booklets";
import CoinsSlider from "./components/coins-slider";
import CopyLink from "./components/copy-link";
import {FiltersDatepicker} from "./components/filters-datepicker";
import Modal from "./components/modal";
import OverviewAwardsSlider from "./components/overview-awards";
import Select from "./components/select";
import {Sidebar} from "./components/sidebar";
import {SidebarDropdown} from "./components/sidebar-dropdown";
import Slider from "./components/slider";
import Tabs from "./components/tabs";
import Toggle from "./components/toggle";

document.addEventListener("DOMContentLoaded", function () {
  Select(); // Логика кастомного селекта
  Toggle(); // Логика аккордеона
  CopyLink(); // Логика для копирования ссылки из URL или data-href атрибута
  Modal(); // Логика для модального окна
  Tabs(); // Логика для табов
  Slider(); // Логика для слайдера
  Sidebar();
  Booklets();
  BlogsSlider();
  OverviewAwardsSlider();
  CoinsSlider();
  FiltersDatepicker();
  SidebarDropdown();
});
